import { QueryClient } from "@tanstack/react-query";

// webService.jsx's fetchWithRetry already retries transient network failures
// 3x with backoff before a query function's promise ever rejects (see
// webService.jsx), so React Query's own retry only needs to cover failures
// that happen outside that layer (a bad response body, a thrown validation
// error) — one extra attempt is enough and avoids stacking two independent
// retry loops on top of each other.
const QUERY_RETRY = 1;
const MUTATION_RETRY = 0; // never silently retry a write (placing an order twice, etc.)

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // data is "fresh" for 30s — avoids refetch storms from remounts/tab switches
      gcTime: 5 * 60_000, // unused cache entries are kept 5min before eviction
      retry: QUERY_RETRY,
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 5000),
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: MUTATION_RETRY,
    },
  },
});
